<template>
  <!-- 图片搜索下拉框 -->
  <Transition name="image-search-dropdown">
    <div
      v-if="show"
      class="image-search-dropdown"
    >
      <div
        @click.stop="handleImageSearchDropdownClick()"
        class="image-search-dropdown-item"
      >
        Find Similar
        <Icon
          class="image-search-dropdown-item-icon"
          name="icon-image-search-similar"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup>
import Icon from '@/components/Icon/Icon.vue'
import { showH5ImageSearchGuide } from '@/components/H5/H5ImageSearchGuide'

const show = defineModel('show', { type: Boolean })

const handleImageSearchDropdownClick = (type) => {
  show.value = false
  showH5ImageSearchGuide()
}
</script>

<style lang='less' scoped>
.image-search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  width: 160px;
  height: 50px;
  background-color: #fff;
  z-index: 999;
  border-radius: 8px;
  outline: 1px solid #dfdfdf;
  padding: 8px 0;

  .image-search-dropdown-item {
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #5c5c5c;
    font-size: 12px;
    font-family: mon-600;

    .image-search-dropdown-item-icon {
      font-size: 20px;
      color: #232323;
    }

    .image-search-dropdown-item-new {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 16px;
      border-radius: 2px;
      background-color: #1153d6;
      color: white;
      font-size: 9px;
      font-family: mon-600;
    }
  }

  .image-search-dropdown-divider {
    width: 136px;
    height: 1px;
    background-color: #dfdfdf;
    margin: 6px auto;
  }
}

// 下拉动画
.image-search-dropdown-enter-active,
.image-search-dropdown-leave-active {
  transition: all 0.3s ease-in-out;
}

.image-search-dropdown-enter-from,
.image-search-dropdown-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
